import { ISlotViewItem } from '../../types/interfaces/Slots/Slots';
import { IGetGameUrl } from '../../types/slot';
import { IIPlatipusGetUrl } from '../../types/interfaces/Slots/Platipus';
import { IConvertGameList, ISlotConverter } from '../../types/converter';
import { getTab } from './utils';
import { CasinoType } from 'modules/Casino/types/configuration';

class Converter implements ISlotConverter {
  convertGameList = ({ data, extraData }: IConvertGameList<any[]>): ISlotViewItem[] =>
    data
      .filter(item => item.game_id !== 'vegasholdem')
      .map(item => ({
        id: item.game_id,
        gameId: item.game_id,
        type: CasinoType.slots,
        description: item.name,
        gameName: item.name,
        tab: getTab(item.game_id),
        provider: 'platipus',
        imageUrl: `/images/platipus/${item.game_id}.png`,
        routeProvider: 'platipus',
      }));

  convertGameUrl = ({ data }: IGetGameUrl<IIPlatipusGetUrl, unknown>) => data.launch_url;
}
export default Converter;
